import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import info from './styles'

export default class extends PureComponent {
  static propTypes = {
    event: PropTypes.object
  }

  render() {
    const { event } = this.props
    return (
      <div className="content">
        <h4 className="header highlight">Cita de visita de muestra</h4>

        <p className="label">Ubicación:</p>
        <p className="value">
          {event.address} <br />
          <a
            className="highlight"
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=${event.lat},${event.lng}`}
          >
            Ver en Google Maps
          </a>
        </p>

        <p className="label">Usuario:</p>
        <p className="value">Nombre y Apellido</p>

        <p className="label">Mail:</p>
        <p className="value">neto@neto.com</p>

        <p className="label">Telefónos:</p>

        <p className="value">(55) 1234 5678</p>

        <h4 className="header">Interesado</h4>

        <p className="label">Usuario:</p>
        <p className="value">Nombre y Apellido de interesado</p>

        <p className="label">Mail:</p>
        <p className="value">neto@neto.com</p>

        <p className="label">Telefónos:</p>

        <p className="value">(55) 1234 5678</p>
        <p className="value">(55) 1234 5678</p>

        <style jsx>{info}</style>
      </div>
    )
  }
}
